export const AUTHENTICATION_CODE_LENGTH = 6;

export enum Source {
  SOURCE_MANUAL = 0,
  SOURCE_ACTIVEDIR = 1,
  SOURCE_VIFOR = 2,
  SOURCE_SSO_SAML = 4,
}

export enum IdentityProviderAuthorizationLocation {
  BROWSER = 1,
}
